import { isValidEmail } from '@pff-consumer/utils'

export type CreateAccountValidation = {
  validEmail: boolean
  emailErrorMessage: string
  validPassword: boolean
  isValid: boolean
}

export const formValidators: CreateAccountValidation = {
  validEmail: true,
  emailErrorMessage: '',
  validPassword: false,
  isValid: false,
}

export const FANTASY_SYNC = {
  MINIMUM_PASSWORD_SIZE: 8,
} as const

export const createAccountformValidators = (email: string, password: string): CreateAccountValidation => {
  if (email === '') {
    formValidators.validEmail = false
    formValidators.emailErrorMessage = 'Email is required.'
  } else if (!isValidEmail(email)) {
    formValidators.validEmail = false
    formValidators.emailErrorMessage = 'Please enter a valid email address.'
  } else {
    formValidators.validEmail = true
    formValidators.emailErrorMessage = ''
  }

  if (password === '' || password.length < FANTASY_SYNC.MINIMUM_PASSWORD_SIZE) {
    formValidators.validPassword = false
  } else {
    formValidators.validPassword = true
  }
  formValidators.isValid = formValidators.validEmail && formValidators.validPassword
  return formValidators
}
